import { Dispatch, FC, ReactNode, SetStateAction } from "react";
import TableForm from "@lhd/components/TableForm";
import useTableList, { Props } from "./hook";
import type { ReceivedProps } from "./type";
import { Styles } from "./styled";
import FilterPanel from "@lhd/features/Apps/AppList/ManagementAppSheet/ManagementAppSheetList/AppSheetComponents/FilterPanelWrapper/FilterPanel";

const TableListLayout = (props: Props) => {
  const {
    filterInfo,
    setFilterInfo,
    filter,
    filterData,
    selectedFilterOptions,
    selectedFilterType,
    handleSetFilter,
    isFetchingFilterOptions,
    hideSpecialEmptyCheckbox,
    headerHeight,
    displaySize,
    tableFormRef,
    getRowIdForForm,
    ...tableProps
  } = props as Props & {
    filterInfo?: {
      open?: boolean;
      columnId: string | number | null;
      position?: { x: number; y: number };
    };
    setFilterInfo?: Dispatch<
      SetStateAction<{
        open?: boolean;
        columnId: string | number | null;
        position?: { x: number; y: number };
      }>
    >;
    filter?: Record<string, unknown>;
    filterData?: Record<string, string[]>;
    selectedFilterOptions?: { value: string | number; label: string }[];
    selectedFilterType?: string;
    handleSetFilter?: (v: Record<string, unknown>) => void;
    isFetchingFilterOptions?: boolean;
    hideSpecialEmptyCheckbox?: boolean;
    headerHeight?: number;
    displaySize?: "small" | "medium" | "large";
    elementBetweenHeaderAndTable?: ReactNode;
  };

  return (
    <Styles className="lhd-tracking-list-table" text_scale={displaySize}>
      <TableForm
        ref={tableFormRef}
        {...(tableProps as any)}
        headerHeight={headerHeight}
        displaySize={displaySize}
        getRowIdForForm={getRowIdForForm}
        autoFitRemainingHeight
      />
      {filterInfo?.position && filterInfo?.columnId != null && setFilterInfo && (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <FilterPanel
            key={String(filterInfo.columnId)}
            filterInfo={filterInfo as any}
            position={filterInfo.position}
            columnId={String(filterInfo.columnId)}
            setFilterInfo={setFilterInfo as any}
            filterDataFull={filterData as any}
            filterData={filterData as any}
            handleSetFilter={handleSetFilter as any}
            filter={filter as any}
            open={!!filterInfo.open}
            type={selectedFilterType}
            enableTimeTree={selectedFilterType === "time"}
            options={selectedFilterOptions as any}
            isFetchingOptions={isFetchingFilterOptions}
            hideSpecialEmptyCheckbox={hideSpecialEmptyCheckbox}
          />
        </div>
      )}
    </Styles>
  );
};

const TableList: FC<ReceivedProps> = (props) => (
  <TableListLayout {...useTableList(props)} />
);

export default TableList;
